export default __webpack_public_path__ + "static/aws-aec9f7cd6003ecba5cdf2c7be232fad2.svg";